/** @type {import('@nuxt/types').Plugin} */
export default ({ app, error, redirect }) => {
    app.errorUnauthorized = () => {
        app.$tidalAuth.saveReturnUrl();
        redirect(app.localePath('login'));
    };
    app.errorContentBlocked = () => error({ statusCode: 403, message: 'CONTENT_BLOCKED' });
    app.errorNotFound = () => error({ statusCode: 404 });
};
